import React from 'react';
import { ownerVerifiedContent } from './contentConfig';
import { ShieldCheck, Award, Briefcase } from 'lucide-react';

const ProofV2 = () => {
  return (
    <section className="py-16 md:py-24 bg-background border-t border-border">
      <div className="container px-4 md:px-6 mx-auto max-w-5xl text-center">
        <h2 className="text-3xl font-bold tracking-tight md:text-4xl mb-4">
          Confiança vem de prova verificável e de limites claros.
        </h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-16">
          Publicamos credenciais, experiência e casos somente com contexto, data-base, escopo e fonte de verificação. Depoimentos são exibidos com autorização.
        </p>

        <div className="grid md:grid-cols-3 gap-8 text-left">
          <div className="p-6 border rounded-xl bg-card shadow-sm">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-6 text-primary">
              <ShieldCheck className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Atuação Profissional</h3>
            <p className="text-muted-foreground">{ownerVerifiedContent.professionalName}</p>
            <p className="text-sm text-muted-foreground mt-2">{ownerVerifiedContent.professionalRole}</p>
          </div>

          <div className="p-6 border rounded-xl bg-card shadow-sm">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-6 text-primary">
              <Briefcase className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Relações Comerciais</h3>
            <p className="text-muted-foreground">{ownerVerifiedContent.administrators}</p>
            <p className="text-sm text-muted-foreground mt-2">{ownerVerifiedContent.ademiconRelationship}</p>
          </div>

          <div className="p-6 border rounded-xl bg-card shadow-sm">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-6 text-primary">
              <Award className="w-6 h-6" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Experiência</h3>
            <p className="text-muted-foreground">{ownerVerifiedContent.technologyExperience}</p>
          </div>
        </div>

        <div className="mt-16 max-w-3xl mx-auto p-8 border rounded-xl bg-muted/30">
          <p className="italic text-lg text-foreground mb-4">"{ownerVerifiedContent.testimonial}"</p>
          <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wider">Depoimento de Cliente (Autorizado)</p>
        </div>
      </div>
    </section>
  );
};

export default ProofV2;
